<script>
import store from '../../store/index.js';

export default {
    data() {
        return {
            allPay: 2, // 1 贷款买车，2 全款买车
            loan: {
            prepayment: '',
            monthPay: '',
            spanLoanMoreCostTop: ''
            }, // 贷款
            maintainTotal: '--', // 养车费用总计
            maintainTips: '', // 养车模块提醒
            maintain: '--', // 保养费用
            oilFee: '--', // 油费
            compulsoryPay: '--', //交强险
            thridPay: '--', // 第三者责任险
            lossPay: '--', // 车辆损失险
            excessPay: '--', // 不计免赔险
            isWholeBuyCar: true, // 是否全款买车
            carPrice: '', // 裸车价格
            prepayment: '', // 首付额度
            prepaymentType: '', // 首付额度类型
            loanTypeForYear: '', // 还款年限
            totalPrice: 0, // 预计花费总额
            allNeedCost: '',
            allCommercialInsurance: '',
            floatLeyerType: '',
            secondListCheckValue: '',
            firstList: {},  // 一级菜单展示模块数据
            secondList: {}, // 二级菜单展示模块数据
            floatLeyerData: null,
            // 必要花费模块
            needCostList: {
            purchaseTax: {
                id: 'purchaseTax',
                name: '购置税',
                value: '',
                showCheck: false,
                haveSecondList: false,
                check: true
            },
            consumptionTax: {
                id: 'consumptionTax',
                name: '消费税',
                value: '',
                haveSecondList: false,
                check: true
            },
            licenseTax: {
                id: 'licenseTax',
                name: '上牌费用',
                value: '',
                showCheck: false,
                haveSecondList: false,
                check: true
            },
            usageTax: {
                id: 'usageTax',
                name: '车船使用税',
                value: '',
                subName: '',
                subValue: '',
                showCheck: false,
                haveSecondList: true,
                subDes: '',
                check: true
            },
            trafficInsurance: {
                id: 'trafficInsurance',
                name: '交通事故责任强制保险',
                value: '',
                subName: '',
                subValue: '',
                showCheck: false,
                haveSecondList: true,
                subDes: '',
                check: true
            }
            },
            // 车船使用税
            usageTaxList: {
            title: '车船使用税',
            list: [
                {
                name: '1.0L（含）以下',
                value: 1,
                type: 'usageTax'
                },
                {
                name: '1.0~1.6L（含）',
                value: 2,
                type: 'usageTax'
                },
                {
                name: '1.6~2.0L（含）',
                value: 3,
                type: 'usageTax'
                },
                {
                name: '2.0~2.5L（含）',
                value: 4,
                type: 'usageTax'
                },
                {
                name: '2.5~3.0L（含）',
                value: 5,
                type: 'usageTax'
                },
                {
                name: '3.0~4.0L（含）',
                value: 6,
                type: 'usageTax'
                },
                {
                name: '4.0以上',
                value: 7,
                type: 'usageTax'
                }
            ]
            },
            usageTaxCheck: {
            name: '1.6~2.0L（含）',
            value: 3
            },
            // 座位类型
            seatTypeList: {
            title: '交通事故责任强制保险',
            list: [
                {
                name: '家用6座以下',
                value: 1,
                type: 'seatType'
                },
                {
                name: '家用6座及以上',
                value: 2,
                type: 'seatType'
                }
            ]
            },
            seatTypeCheck: {
            name: '家用6座以下',
            value: 1
            },
            // 商业保险模块
            commercialInsuranceList: {
            thirdInsurance: {
                id: 'thirdInsurance',
                name: '第三者责任险',
                value: '',
                showCheck: true,
                haveSecondList: true,
                check: true,
                subDes: ''
            },
            damageInsurance: {
                id: 'damageInsurance',
                name: '车辆损失险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            stolenInsurance: {
                id: 'stolenInsurance',
                name: '全车盗抢险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            glassInsurance: {
                id: 'glassInsurance',
                name: '玻璃单独破碎险',
                value: '',
                showCheck: true,
                haveSecondList: true,
                check: true,
                subDes: ''
            },
            combustionInsurance: {
                id: 'combustionInsurance',
                name: '自燃损失险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            noDeductibleInsurance: {
                id: 'noDeductibleInsurance',
                name: '不计免赔特约险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            noLiabilityInsurance: {
                id: 'noLiabilityInsurance',
                name: '无过责任险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            passengerInsurance: {
                id: 'passengerInsurance',
                name: '车上人员责任险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            scratchInsurance: {
                id: 'scratchInsurance',
                name: '车身划痕险',
                value: '',
                showCheck: true,
                haveSecondList: true,
                check: true,
                subDes: ''
            },
            waterInsurance: {
                id: 'waterInsurance',
                name: '涉水险',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            },
            allCommercialInsurance: {
                id: 'allCommercialInsurance',
                name: '商业保险总计',
                value: '',
                showCheck: true,
                haveSecondList: false,
                check: true
            }
            },
            // 第三者责任险
            thirdInsuranceTypeList: {
            title: '第三者责任险',
            list: [
                {
                name: '5万',
                value: 1,
                type: 'thirdInsurance'
                },
                {
                name: '10万',
                value: 2,
                type: 'thirdInsurance'
                },
                {
                name: '20万',
                value: 3,
                type: 'thirdInsurance'
                },
                {
                name: '50万',
                value: 4,
                type: 'thirdInsurance'
                },
                {
                name: '100万',
                value: 5,
                type: 'thirdInsurance'
                },
            ]
            },
            thirdInsuranceTypeCheck: {
            name: '10万',
            value: 2
            },
            // 玻璃单独破碎险
            glassInsuranceList: {
            title: '玻璃单独破碎险',
            list: [
                {
                name: '国产',
                value: 1,
                type: 'glassInsurance'
                },
                {
                name: '进口',
                value: 2,
                type: 'glassInsurance'
                }
            ]
            },
            glassInsuranceCheck: {
            name: '国产',
            value: 1
            },
            // 车身划痕险类型
            scratchInsuranceTypeList: {
            title: '车身划痕险类型',
            list: [
                {
                name: '2千',
                value: 1,
                type: 'scratchInsurance'
                },
                {
                name: '5千',
                value: 2,
                type: 'scratchInsurance'
                },
                {
                name: '1万',
                value: 3,
                type: 'scratchInsurance'
                },
                {
                name: '2万',
                value: 4,
                type: 'scratchInsurance'
                }
            ]
            },
            scratchInsuranceTypeCheck: {
            name: '5千',
            value: 2,
            },
            // 首付额度类型
            prepaymentTypeList: {
            title: '请选择首付额度',
            list: [
                {
                showBottomName: 30,
                type: 'prepayment',
                name: '30%',
                value: 1
                },
                {
                showBottomName: 40,
                type: 'prepayment',
                name: '40%',
                value: 2
                },
                {
                showBottomName: 50,
                type: 'prepayment',
                name: '50%',
                value: 3
                },
                {
                showBottomName: 60,
                type: 'prepayment',
                name: '60%',
                value: 4
                }
            ]
            },
            prepaymentTypeCheck: {
            showBottomName: 30,
            type: 'prepayment',
            name: "30%",
            value: 1
            },
            // 贷款年限
            loanTypeForYearList: {
            title: '请选择还款年限',
            list: [
                {
                name: 1,
                type: 'loanforyear',
                value: 1
                },
                {
                name: 2,
                type: 'loanforyear',
                value: 2
                },
                {
                name: 3,
                type: 'loanforyear',
                value: 3
                },
                {
                name: 4,
                type: 'loanforyear',
                value: 4
                },
                {
                name: 5,
                type: 'loanforyear',
                value: 5
                }
            ]
            },
            loanTypeForYearCheck: {
            name: 3,
            type: 'loanforyear',
            value: 3
            },
            // 是否展示向上弹窗
            isShowPopUpBox: false,
            // 向上弹窗内容
            popUpData: {},
            popUpDataCheck: {}
        }
    },
    computed: {
        lowerPrice() {
            return store.price.lower.lastMonthDealPrice;
        },
        normalPrice() {
            return store.price.normal.price;
        },
       
        price(){
            return this.lowerPrice ? this.lowerPrice : !this.lowerPrice && this.normalPrice?  this.normalPrice : '' ;
        }
    },
    watch:{
        price:function(newVal){
            if(newVal) {
                this.carPrice=newVal;
                this.getCostList();
            }else {
                this.carPrice=newVal;
            }
        }
    },
    methods:{
        async getCostList(){
            var _this = this;
            var params = {
                carPrice: _this.price,
                allPay: _this.allPay,
                displacementType: _this.usageTaxCheck.value,
                seatType: _this.seatTypeCheck.value,
                thirdInsuranceType: _this.thirdInsuranceTypeCheck.value,
                glassInsuranceType: _this.glassInsuranceCheck.value,
                scratchInsuranceType: _this.scratchInsuranceTypeCheck.value
            }
            if (_this.allPay == 1) {
                params.prepayment = '',
                params.prepaymentType = _this.prepaymentTypeCheck.value;
                params.loanTypeForYear = _this.loanTypeForYearCheck.value
            }

            const res =await store.costList(params);
            console.log(res);
            if (res.status === 1) {
                var data = res.data;
                if (_this.allPay == 1) {
                    // 贷款买车花费总额
                    _this.totalPrice = (data.spanTotalTop + data.spanLoanMoreCostTop).toFixed(0);
                    _this.loan = data.loan;
                    _this.loan.spanLoanMoreCostTop = data.spanLoanMoreCostTop;
                } else {
                    // 全款买车花费总额
                    _this.totalPrice = data.spanTotalTop
                }
                // 必要花费赋值
                _this.allNeedCost = data.needCost.allNeedCost
                _this.needCostList.consumptionTax.value = data.needCost.consumptionTax
                _this.needCostList.licenseTax.value = data.needCost.licenseTax
                _this.needCostList.purchaseTax.value = data.needCost.purchaseTax
                _this.needCostList.trafficInsurance.value = data.needCost.trafficInsurance
                _this.needCostList.usageTax.value = data.needCost.usageTax
                // 给subDes赋值
                for (var i = 0; i < _this.usageTaxList.list.length; i++) {
                    if (_this.usageTaxList.list[i].value === _this.usageTaxCheck.value) {
                    _this.needCostList.usageTax.subDes = _this.usageTaxList.list[i].name
                    }
                }
                for (var i = 0; i < _this.seatTypeList.list.length; i++) {
                    if (_this.seatTypeList.list[i].value === _this.seatTypeCheck.value) {
                    _this.needCostList.trafficInsurance.subDes = _this.seatTypeList.list[i].name
                    }
                }
                // 商业保险赋值
                _this.allCommercialInsurance = data.commercialInsurance.allCommercialInsurance
                _this.commercialInsuranceList.combustionInsurance.value = data.commercialInsurance.combustionInsurance
                _this.commercialInsuranceList.damageInsurance.value = data.commercialInsurance.damageInsurance
                _this.commercialInsuranceList.glassInsurance.value = data.commercialInsurance.glassInsurance
                _this.commercialInsuranceList.noDeductibleInsurance.value = data.commercialInsurance.noDeductibleInsurance
                _this.commercialInsuranceList.noLiabilityInsurance.value = data.commercialInsurance.noLiabilityInsurance
                _this.commercialInsuranceList.passengerInsurance.value = data.commercialInsurance.passengerInsurance
                _this.commercialInsuranceList.scratchInsurance.value = data.commercialInsurance.scratchInsurance
                _this.commercialInsuranceList.stolenInsurance.value = data.commercialInsurance.stolenInsurance
                _this.commercialInsuranceList.thirdInsurance.value = data.commercialInsurance.thirdInsurance
                _this.commercialInsuranceList.waterInsurance.value = data.commercialInsurance.waterInsurance
                // 给subDes赋值
                for (var i = 0; i < _this.thirdInsuranceTypeList.list.length; i++) {
                    if (_this.thirdInsuranceTypeList.list[i].value === _this.thirdInsuranceTypeCheck.value) {
                    _this.commercialInsuranceList.thirdInsurance.subDes = _this.thirdInsuranceTypeList.list[i].name
                    }
                }
                for (var i = 0; i < _this.glassInsuranceList.list.length; i++) {
                    if (_this.glassInsuranceList.list[i].value === _this.glassInsuranceCheck.value) {
                    _this.commercialInsuranceList.glassInsurance.subDes = _this.glassInsuranceList.list[i].name
                    }
                }
                for (var i = 0; i < _this.scratchInsuranceTypeList.list.length; i++) {
                    if (_this.scratchInsuranceTypeList.list[i].value === _this.scratchInsuranceTypeCheck.value) {
                    _this.commercialInsuranceList.scratchInsurance.subDes = _this.scratchInsuranceTypeList.list[i].name
                    }
                }
                // 总额以及商业保险减去商业保险勾选掉的价格
                for (var item in _this.commercialInsuranceList) {
                    if (!_this.commercialInsuranceList[item].check) {
                    _this.allCommercialInsurance = _this.allCommercialInsurance - _this.commercialInsuranceList[item].value;
                    _this.totalPrice = _this.totalPrice - _this.commercialInsuranceList[item].value;
                    }
                }
            }
        },
        // 全款买车 || 贷款买车按钮
        bottomButtonClick: function (type) {
        if (type === 'wholeBuyCar') {
            this.isWholeBuyCar = true;
            this.allPay = 2;
        } else {
            this.isWholeBuyCar = false;
            this.allPay = 1;
        }
            this.getCostList();
        },


    }
}
</script>

<template>
   
    <div class="car-calc page-main__card">
        <ul class="car-calc__menu">
            <li class="car-calc__menu-item" :class="{'car-calc__menu-item--current': isWholeBuyCar}" @click="bottomButtonClick('wholeBuyCar')">全款买车</li>
            <li class="car-calc__menu-item" :class="{'car-calc__menu-item--current': !isWholeBuyCar}" @click="bottomButtonClick('loanBuyCar')">贷款买车</li>
        </ul>
        <ul class="car-calc__content">
            <li class="full-payment" v-show="isWholeBuyCar">
                <div class="total-price">
                    <h5>预计花费总额</h5>
                    <div>裸车价(<span>{{carPrice || '--'}}</span>) + 必要花费 + 商业保险</div>
                    <p>
                        <strong>{{totalPrice || '--'}}</strong>
                        <em>元</em>
                    </p>
                </div>
                <ul class="button-group">
                    <li class="button" >
                        <h6 class="button__title">必要花费</h6>
                        <p class="button__text">{{allNeedCost || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                    <li class="button" >
                        <h6 class="button__title">商业保险</h6>
                        <p class="button__text">{{allCommercialInsurance || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                </ul>
            </li>
            <li class="loan-payment" v-show="!isWholeBuyCar">
                <div class="total-price">
                    <h5>预计花费总额</h5>
                    <div>裸车价(<span>{{carPrice || '--'}}</span>) + 必要花费 + 商业保险 + 多花费</div>
                    <p>
                        <strong>{{totalPrice || '--'}}</strong>
                        <em>元</em>
                    </p>
                </div>
                <ul class="loan-info">
                    <li class="loan-info__down-payments">
                        <strong>{{loan.prepayment || '--'}}</strong>
                        <em>首付（元）</em>
                    </li>
                    <li class="loan-info__monthly-payment">
                        <strong>{{loan.monthPay || '--'}}</strong>
                        <em>月供（元）</em>
                    </li>
                    <li class="loan-info__more-cost">
                        <strong>{{loan.spanLoanMoreCostTop || '--'}}</strong>
                        <em>多花费（元）</em>
                    </li>
                </ul>
                <ul class="button-group">
                    <li class="button" >
                        <h6 class="button__title">首付额度（%）</h6>
                        <p class="button__text">{{prepaymentTypeCheck.showBottomName || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                    <li class="button">
                        <h6 class="button__title">还款年限（年）</h6>
                        <p class="button__text">{{loanTypeForYearCheck.name || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                    <li class="button">
                        <h6 class="button__title">必要花费</h6>
                        <p class="button__text">{{allNeedCost || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                    <li class="button">
                        <h6 class="button__title">商业保险</h6>
                        <p class="button__text">{{allCommercialInsurance || '--'}}</p>
                        <button class="leads-icon icon__more1"></button>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
                
</template>

<style lang="stylus" scoped>

.car-calc {
  padding: 16px 0 0;
}
.car-calc__menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
      justify-content: space-around;
}
.car-calc__menu-item {
  margin:0;
  padding: 0 0 12px;
  font-size: 16px;
  line-height: 16px;
  color: #0e1f39;
}
.car-calc__menu-item--current {
  position: relative;
  font-weight: bold;
}
.car-calc__menu-item--current:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 35px;
  height: 5px;
  border-radius: 5px;
  background-color: #FF6600;
  -webkit-box-shadow: 0 2px 3px 0 rgba(75,118,246,0.05);
          box-shadow: 0 2px 3px 0 rgba(75,118,246,0.05);
  -webkit-transform: translate(-50%, 0);
          transform: translate(-50%, 0);
}
.car-calc__content {
  padding: 0 18px;
}
.car-calc__content .total-price {
  margin: 26px 0 0;
  padding: 0 0 10px;
}
.car-calc__content .total-price h5 {
  padding: 0 0 5px;
  font-size: 14px;
  margin:0px;
  line-height: 14px;
  color: #737d87;
}
.car-calc__content .total-price h5 + div {
  display: block;
  padding: 0 0 5px;
  font-size: 12px;
  color: #9a9a9a;
  line-height: 12px;
  height: 12px;
}
.car-calc__content .total-price p {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  color: #ff4a3a;
}
.car-calc__content .total-price p strong {
  font-size: 34px;
  line-height: 34px;
  font-weight: bold;
}
.car-calc__content .total-price p em {
  margin: 0 0 0 5px;
  font-size: 15px;
  line-height: 15px;
}
.car-calc__content .loan-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 -18px;
  background: url("../../../assets/v2.1__bg.png") no-repeat center/cover;
}

.car-calc__content .loan-info li {
  width: 33.3333%;
  padding: 15px 0;
  text-align: center;
}
.car-calc__content .loan-info li strong {
  display: block;
  margin: 0 0 11px;
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  color: #fff;
}
.car-calc__content .loan-info li em {
  display: block;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
}
.car-calc__content .button-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.car-calc__content .button-group .button {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  position: relative;
  width: 50%;
  padding: 10px 30px 16px 0;
  border-bottom: 1px solid #e6e6e6;
}
.car-calc__content .button-group .button:last-of-type,
.car-calc__content .button-group .button:nth-last-child(2):not(:nth-child(2n)) {
  border-bottom: none;
}
.car-calc__content .button-group .button__title {
  font-size: 14px;
  line-height: 14px;
  color: #737d87;
  margin:0;
}
.car-calc__content .button-group .button__text {
  margin: 15px 0 0;
  font-size: 15px;
  font-weight: bold;
  line-height: 15px;
  color: #08203b;
}
.car-calc__content .button-group .button .icon__more1 {
  position: absolute;
  top: 50%;
  right: 19px;
  -webkit-transform: translate(0, -50%);
          transform: translate(0, -50%);
  width: 11px;
  height: 11px;
}
</style>